import { useEffect, useRef, useState } from 'react';
import { Button, ClassifyStructure, Col, DateTimePicker, Form, Input, InputNumber, MainModal, message, Modal, ProTableOt, Row, Select, Seperator, setParamsFilter, Tabs, TreeSelect, Typography, useProTableOt, Tag, Card } from './../../ui/ot'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAttribute } from './../controllers/attribute_controller'
import { usePosition } from './../controllers/position_controller'
import { useDepth } from './../controllers/depth_controller'
import { createContext } from 'react';
import { useContext } from 'react';
import PositionTest from './position_test';
import dayjs from 'dayjs';

const LanguageContext = createContext(null);

const PositionManagement = ({
    actionRef: actionRef_,
    api = `/inventory_check/api/position`,
    keyPrefix = 'inventory_check.position',
    extraActionRender = () => { },
    customFormItems = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseAttribute = useAttribute,
    propsOnValueChange = () => { },
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    onSelectChange = () => { },
    propsActiveTabHidden = true,
    propsActiveKey = '',
    propsModeActiveTabHidden = false,
    propsModeActiveKey = 'list',
    customColumns = [],
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    initialValues = {},
    extraParams,
    defaultValue = {},
    depth = 0,
    only_depth = 0,
    get_position_mode = 'top',
    rowSelectionMode = "checkbox",
    propsLoading,
    propsSetLoading,
    propsShowKeys = [
        { key: "name", name: "name", hidden: false, require: false },
        { key: "name_en", name: "name_en", hidden: false, require: false },
        { key: "location", name: "location", hidden: false, require: false },
        { key: "space", name: "space", hidden: false, require: false },
        { key: "capacity", name: "capacity", hidden: false, require: false },
        { key: "row", name: "row", hidden: false, require: false },
        { key: "column", name: "column", hidden: false, require: false },
        { key: "height", name: "height", hidden: false, require: false },
        { key: "position_attribute_data", name: "position_attribute_data", hidden: false, require: false },
        { key: "Seperator1", name: "Seperator1", hidden: false, require: false },
        { key: "Seperator2", name: "Seperator2", hidden: false, require: false },
        { key: "x", name: "x", hidden: false, require: false },
        { key: "y", name: "y", hidden: false, require: false },
        { key: "z", name: "z", hidden: false, require: false },
        { key: "max", name: "max", hidden: false, require: false },
        { key: "min", name: "min", hidden: false, require: false },
        { key: "row", name: "row", hidden: false, require: false },
        { key: "column", name: "column", hidden: false, require: false },
        { key: "height", name: "height", hidden: false, require: false },
    ],
    readonly = false,
    propsClassifyStructureTypeId = 0,
    cardRender,
    showSearch = true,
    reloadButton = true,
    manageColumnsButton = true,
    endMessage,
    cardModeSetting = {
        columnsCount: 2,
        singleRowHeight: '100vh',
    },
    layoutMode,
    propsCardRenderMode = 'origin',
    propsCustomRender = () => <></>,
    propsDepthTabs = true,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form] = Form.useForm();
    const [count, setCount] = useState(0)
    const [searchParams] = useSearchParams()
    const { menu_id } = Object.fromEntries([...searchParams])
    const current_menu_id = useRef(menu_id)
    const [forceReload, setForceReload] = useState(0)
    const [activeKey, setActiveKey] = useState(t(propsActiveKey))
    const [modeActiveKey, setModeActiveKey] = useState(t(propsModeActiveKey))
    const [loading_, setLoading_] = useState(false)
    const [loading, setLoading] = [propsLoading ?? loading_, propsSetLoading ?? setLoading_]
    const [depthIndex, setDepthIndex] = useState(undefined)
    const selectRef = useRef();
    const actionRef = actionRef_ ?? selectRef
    const defaultColumns = [
        // {
        //     title: t("position_name_language_data_tw"),
        //     key: "name",
        //     dataIndex: "name",
        //     canFilter: true,
        //     filterType: 'search',
        //     width: "10rem",
        //     render: (text, record, index) =>
        //         (
        //             record?.name_language_data || []
        //         )?.find(
        //             (tmp) =>
        //                 tmp?.language_culture_code ===
        //                 "zh-tw"
        //         )?.language_culture_value || "-",
        // },
        // {
        //     title: t("position_name_language_data_en"),
        //     key: "name_en",
        //     dataIndex: "name_language_data",
        //     canFilter: true,
        //     filterType: 'search',
        //     width: "10rem",
        //     render: (text, record, index) =>
        //         (
        //             record?.name_language_data || []
        //         )?.find(
        //             (tmp) =>
        //                 tmp?.language_culture_code === "en"
        //         )?.language_culture_value || "-",
        // },
        // {
        //     title: t('depth_data'),
        //     key: "depth_data",
        //     dataIndex: "depth_data",
        //     canFilter: true,
        //     filterType: 'search',
        //     width: "10rem",
        //     render: (text, record, index) =>
        //         (
        //             record?.depth_data?.find(_ => true)?.name_language_data || []
        //         )?.find(
        //             (tmp) =>
        //                 tmp?.language_culture_code === "zh-tw"
        //         )?.language_culture_value || "-",
        // },
        // {
        //     title: t('location'),
        //     key: "location",
        //     dataIndex: "location",
        //     canFilter: true,
        //     filterType: 'search',
        //     width: "10rem",
        //     render: (text, record, index) => <>
        //         <Row>
        //             <Col span={24}>
        //                 x：{record?.x}
        //             </Col>
        //             <Col span={24}>
        //                 y：{record?.y}
        //             </Col>
        //             <Col span={24}>
        //                 z：{record?.z}
        //             </Col>
        //         </Row>
        //     </>
        // },
        // {
        //     title: t('space'),
        //     key: "space",
        //     dataIndex: "space",
        //     canFilter: true,
        //     filterType: 'search',
        //     width: "10rem",
        //     render: (text, record, index) => <>
        //         <Row>
        //             <Col span={24}>
        //                 row：{record?.row}
        //             </Col>
        //             <Col span={24}>
        //                 column：{record?.column}
        //             </Col>
        //             <Col span={24}>
        //                 height：{record?.height}
        //             </Col>
        //         </Row>
        //     </>
        // },
        // {
        //     title: t('capacity'),
        //     key: "capacity",
        //     dataIndex: "capacity",
        //     canFilter: true,
        //     filterType: 'search',
        //     width: "10rem",
        //     render: (text, record, index) => <>
        //         <Row>
        //             <Col span={24}>
        //                 max：{record?.max}
        //             </Col>
        //             <Col span={24}>
        //                 min：{record?.min}
        //             </Col>
        //         </Row>
        //     </>
        // },
    ]
    const [default_column, set_default_column] = useState([...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true))]);

    const formItemsRender = ({ propsShowKeys }) => {
        return (
            <Row>
                <Col span={24}>
                    <Row>
                        <Col span={12}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "classify_structure_type_id"
                            })?.hidden}>
                            <Form.Item
                                label={t('classify_structure_type_id')}
                                name={'classify_structure_type_id'}
                                rules={[
                                    {
                                        required: propsShowKeys?.find((element) => {
                                            return element.name === "classify_structure_type_id"
                                        })?.require,
                                        message: "請填寫"
                                    }
                                ]}
                            >
                                <TreeSelect
                                    treeData={PositionData}
                                    multiple={false}
                                    treeDefaultExpandAll
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "nameEn"
                            })?.hidden}>
                            <Form.Item
                                label={t('nameEn')}
                                name={'nameEn'}
                                rules={[
                                    {
                                        required: propsShowKeys?.find((element) => {
                                            return element.name === "nameEn"
                                        })?.require,
                                        message: "請填寫"
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "code"
                            })?.hidden}>
                            <Form.Item
                                label={t('code')}
                                name={'code'}
                                rules={[
                                    {
                                        required: propsShowKeys?.find((element) => {
                                            return element.name === "code"
                                        })?.require,
                                        message: "請填寫"
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "property_json.說明"
                            })?.hidden}>
                            <Form.Item
                                name="property_json.說明"
                                label={t('note')}
                                rules={[
                                    {
                                        required: propsShowKeys?.find((element) => {
                                            return element.name === "property_json.說明"
                                        })?.require,
                                        message: "請填寫"
                                    }
                                ]}
                            >
                                <Input
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}
                    hidden={propsShowKeys?.find((element) => {
                        return element.name === "Seperator1"
                    })?.hidden}
                >
                    <Seperator />
                </Col>
                <Col span={24}>
                    <Row>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "location"
                            })?.hidden}
                        >
                            <Typography.Title level={4}>
                                {t('location')}
                            </Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Row>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "x"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('x')}
                                        name={'x'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "x"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "y"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('y')}
                                        name={'y'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "y"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "z"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('z')}
                                        name={'z'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "z"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}
                    hidden={propsShowKeys?.find((element) => {
                        return element.name === "Seperator2"
                    })?.hidden}
                >
                    <Seperator />
                </Col>
                <Col span={24}>
                    <Row>
                        <Col span={24} hidden={propsShowKeys?.find((element) => {
                            return element.name === "capacity"
                        })?.hidden}>
                            <Typography.Title level={4}>
                                {t('capacity')}
                            </Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Row>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "max"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('max')}
                                        name={'max'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "max"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "min"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('min')}
                                        name={'min'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "min"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "row"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('row')}
                                        name={'row'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "row"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "column"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('column')}
                                        name={'column'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "column"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                                <Col span={8}
                                    hidden={propsShowKeys?.find((element) => {
                                        return element.name === "height"
                                    })?.hidden}>
                                    <Form.Item
                                        label={t('height')}
                                        name={'height'}
                                        rules={[
                                            {
                                                required: propsShowKeys?.find((element) => {
                                                    return element.name === "height"
                                                })?.require,
                                                message: "請填寫"
                                            }
                                        ]}
                                    >
                                        <InputNumber />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col span={24}
                    hidden={propsShowKeys?.find((element) => {
                        return element.name === "position_attribute_data"
                    })?.hidden}>
                    <Form.List
                        name={'position_attribute_data'}
                    >
                        {(fields, { add, remove }) => <>
                            <PositionAttributeFormList
                                fields={fields}
                                add={add}
                                remove={remove}
                            />
                        </>}
                    </Form.List>
                </Col>
            </Row>
        );
    };

    const reorganizeFormData = (value, type) => {
        if (type === "submit") {
            let submitValues = { ...value };
            let customMode = 'post';

            let name_language_data = [
                {
                    language_culture_code: "zh-tw",
                    language_culture_value: submitValues?.name,
                },
                {
                    language_culture_code: "en",
                    language_culture_value: submitValues?.nameEn,
                },
            ];
            // let classify_structure_type_id = submitValues?.classify_structure_type_id;
            // if (!submitValues?.classify_structure_type_parent_id) {

            // }
            // if (!!submitValues?.["classify_structure_type_parent_id"] && classify_structure_type_id !== 0) {
            //     classify_structure_type_id = submitValues?.classify_structure_type_parent_id;
            // }
            let property_json = {
                ...submitValues?.property_json,
            };

            if (typeof property_json !== "object") {
                property_json = {}
            }

            let data = {
                ...submitValues,
                name_language_data,
                classify_structure_type_parent_id: submitValues.classify_structure_type_id,
                customMode,
            }
            data = setParamsFilter(data)
            let newData = updateClassifyStructureId([data])
            let firstData = newData.find((ele) => true)
            // let firstData = data
            return {
                ...firstData
            };
        } else if (type === "set") {
            let setValues = { ...value };
            let nameEn = (setValues?.name_language_data || []).find(
                (ele) => {
                    return ele?.language_culture_code === "en";
                }
            )?.language_culture_value;
            setCount(pre => pre + 1)
            return {
                ...setValues,
                classify_structure_type_id: value?.classify_structure_type_parent_id,
                nameEn,
            };
        }
    };

    function updateClassifyStructureId(data,) {
        return data.map(item => {
            // 如果 classify_structure_type_parent_id 存在，將值賦給 classify_structure_id
            // 如果不存在，將 classify_structure_id 設為 0
            // item.classify_structure_type_id = item.classify_structure_type_parent_id || 0;
            if (typeof item.property_json !== "object") {
                item.property_json = {}
            }
            item.property_json = JSON.stringify(item.property_json);
            // 如果有 children，遞迴處理子節點，並將結果回傳給 children
            if (item.children && item.children.length > 0) {
                item.children = updateClassifyStructureId(item.children);

            }
            // 回傳更新後的 item
            return item;
        });
    }

    const {
        PositionData,
        getPositionData,
    } = usePosition({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: ({ values }) => {
        }
    })

    const {
        DepthData,
        getDepthData
    } = useDepth({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: ({ values }) => {
            setLoading(false)
        }
    })

    useEffect(() => {
        if (readonly === false) {
            setForceReload(pre => pre + 1)
        }
        let columns = [];
        DepthData?.forEach(depth_data => {
            if ((depthIndex !== undefined ? 1 : only_depth) == 1) {
                if ((depthIndex !== undefined ? depthIndex : depth) == depth_data?.depth_index) {
                    columns.push(
                        {
                            title: `${depth_data?.depth_name}編號`,
                            key: `${depth_data?.depth_name}編號`,
                            dataIndex: `${depth_data?.depth_name}編號`,
                            canFilter: true,
                            filterType: 'search',
                            width: "10rem",
                            render: (text, record) => <>

                                {record?.all_position_data?.filter(itemItem => itemItem?.depth === depth_data?.depth_index).map(itemItem => <>
                                    {/* 篩選語言 */}
                                    {itemItem?.name_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                        <Row>
                                            <Col span={24}>
                                                <Tag color="geekblue">
                                                    {itemItem?.code}
                                                </Tag>
                                            </Col>
                                        </Row>
                                    </>)}
                                </>)}
                            </>
                        },
                        {
                            title: `${depth_data?.depth_name}名稱`,
                            key: `${depth_data?.depth_name}名稱`,
                            dataIndex: `${depth_data?.depth_name}名稱`,
                            canFilter: true,
                            filterType: 'search',
                            width: "10rem",
                            render: (text, record) => <>
                                {/* 篩選層級 */}
                                {record?.all_position_data?.filter(itemItem => itemItem?.depth === depth_data?.depth_index).map(itemItem => <>
                                    {/* 篩選語言 */}
                                    {itemItem?.name_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                        <Row>
                                            <Col span={24}>
                                                <Tag color="geekblue">
                                                    {itemItemItem?.language_culture_value}
                                                </Tag>
                                            </Col>
                                        </Row>
                                    </>)}
                                </>)}
                            </>
                        },
                        {
                            title: `${depth_data?.depth_name}說明`,
                            key: `${depth_data?.depth_name}說明`,
                            dataIndex: `${depth_data?.depth_name}說明`,
                            canFilter: true,
                            filterType: 'search',
                            width: "10rem",
                            render: (text, record) => <>
                                {record?.all_position_data?.filter(itemItem => itemItem?.depth === depth_data?.depth_index).map(itemItem => <>
                                    {/* 篩選語言 */}
                                    {itemItem?.name_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                        <Row>
                                            <Col span={24}>
                                                <Tag color="geekblue">
                                                    {itemItem?.property_json?.['說明']}
                                                </Tag>
                                            </Col>
                                        </Row>
                                    </>)}
                                </>)}
                            </>
                        },
                    )
                }
            } else {
                columns.push(
                    {
                        title: `${depth_data?.depth_name}編號`,
                        key: `${depth_data?.depth_name}編號`,
                        dataIndex: `${depth_data?.depth_name}編號`,
                        canFilter: true,
                        filterType: 'search',
                        width: "10rem",
                        render: (text, record) => <>

                            {record?.all_position_data?.filter(itemItem => itemItem?.depth === depth_data?.depth_index).map(itemItem => <>
                                {/* 篩選語言 */}
                                {itemItem?.name_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItem?.code}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>
                    },
                    {
                        title: `${depth_data?.depth_name}名稱`,
                        key: `${depth_data?.depth_name}名稱`,
                        dataIndex: `${depth_data?.depth_name}名稱`,
                        canFilter: true,
                        filterType: 'search',
                        width: "10rem",
                        render: (text, record) => <>
                            {/* 篩選層級 */}
                            {record?.all_position_data?.filter(itemItem => itemItem?.depth === depth_data?.depth_index).map(itemItem => <>
                                {/* 篩選語言 */}
                                {itemItem?.name_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItemItem?.language_culture_value}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>
                    },
                    {
                        title: `${depth_data?.depth_name}說明`,
                        key: `${depth_data?.depth_name}說明`,
                        dataIndex: `${depth_data?.depth_name}說明`,
                        canFilter: true,
                        filterType: 'search',
                        width: "10rem",
                        render: (text, record) => <>
                            {record?.all_position_data?.filter(itemItem => itemItem?.depth === depth_data?.depth_index).map(itemItem => <>
                                {/* 篩選語言 */}
                                {itemItem?.name_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem => <>
                                    <Row>
                                        <Col span={24}>
                                            <Tag color="geekblue">
                                                {itemItem?.property_json?.['說明']}
                                            </Tag>
                                        </Col>
                                    </Row>
                                </>)}
                            </>)}
                        </>
                    },
                )
            }

        })
        set_default_column([
            ...columns,
            ...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true)),
            ...customColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true))
        ])
        if (readonly === false) {
            getPositionData({
                ...extraParams,
                depth: depthIndex,
            })
            setLoading(false)
        }
    }, [depthIndex, depth, DepthData])

    useEffect(() => {
        if (readonly === false) {
            getDepthData();
        }
    }, []);
    return <>
        <LanguageContext.Provider value={keyPrefix}>
            <Row>
                {propsDepthTabs && !readonly && <Col>
                    <Tabs
                        activeKey={depthIndex}
                        onChange={setDepthIndex}
                        items={[
                            {
                                key: undefined,
                                tab: t('all')
                            },
                            ...DepthData?.map(item => (
                                {
                                    key: item?.depth_index,
                                    tab: item?.depth_name
                                }
                            ))
                        ]}
                    />
                </Col>}
                {!propsActiveTabHidden &&
                    <Col span={24}>
                        <Tabs
                            activeKey={activeKey}
                            onChange={(e) => setActiveKey(e)}
                            items={[
                                {
                                    key: t(''),
                                    tab: t('')
                                },
                                {
                                    key: t('attribute'),
                                    tab: t('attribute')
                                },
                            ]}
                        />
                    </Col>
                }
                {activeKey === t('') && <>
                    {!propsModeActiveTabHidden &&
                        <Tabs
                            defaultActiveKey={modeActiveKey}
                            activeKey={modeActiveKey}
                            onChange={setModeActiveKey}
                            items={[
                                {
                                    key: t('visualization'),
                                    tab: t('visualization')
                                },
                                {
                                    key: t('list'),
                                    tab: t('list')
                                }
                            ]}
                        />
                    }

                    {modeActiveKey === t('visualization') && <Col span={24}>
                        <VisualizationManagement
                        />
                    </Col>}
                    {/* DB內部的Table inventory_check.depth裡面的資料不得為空，
                    因為上半部有一個function是getDepthData，
                    他會去inventory_check.depth拿資料，
                    如果他拿資料是空的，下方的ClassifyStructure需要inventory_check.depth的資料*/}
                    {modeActiveKey === t('list') && <Col span={24}>
                        {!loading &&
                            <ClassifyStructure
                                selectRef={actionRef}
                                propsForm={form}
                                prefixTitle="position"
                                apiRoute={api}
                                customColumns={default_column}
                                customFormItems={(...props) => {
                                    return <>
                                        {formItemsRender({ propsShowKeys })}
                                        {customFormItems(...props)}
                                    </>
                                }}
                                reorganizeFormData={reorganizeFormData}
                                classify_structure_id={29}
                                classify_structure_type_id={0}
                                initialValues={initialValues}
                                defaultValue={defaultValue}
                                extraParams={{
                                    ...extraParams,
                                    menu_id: current_menu_id.current,
                                    depth: depthIndex ?? depth,
                                    only_depth: depthIndex !== undefined ? 1 : only_depth,
                                    get_position_mode: depthIndex !== undefined ? 'all' : get_position_mode,
                                    classify_structure_type_id: propsClassifyStructureTypeId
                                }}
                                forceReload={forceReload}
                                propsLoading={loading}
                                defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                                defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                                onSelectChange={onSelectChange}
                                propsOnValueChange={propsOnValueChange}
                                custom_multiple_input={true}
                                rowSelectionMode={rowSelectionMode}
                                toolBarRender={toolBarRender}
                                propsPostChildren={!readonly && depthIndex !== undefined && depthIndex !== DepthData?.length - 1}
                                propsChildrenText={DepthData?.find(item => item?.depth_index === depthIndex + 1)?.depth_name}
                                propsPatch={!readonly}
                                propsDelete={!readonly}
                                propsPost={!readonly}
                                propsSort={!readonly}
                                showMode={readonly ? 'card' : 'page'}
                                cardRender={(record, { PatchButton, DeleteButton }) => {
                                    return <>
                                        {cardRender && cardRender(record, { PatchButton, DeleteButton })}
                                        {cardRender === null && (
                                            propsCardRenderMode === "origin" ? (
                                                <Card title={`${record.title}`}>
                                                    {!readonly && (
                                                        <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                                            <Col>{PatchButton}</Col>
                                                            <Col>{DeleteButton}</Col>
                                                        </Row>
                                                    )}
                                                </Card>
                                            ) : propsCardRenderMode === "custom" ? (
                                                propsCustomRender(record, { PatchButton, DeleteButton })
                                            ) : null
                                        )}
                                    </>
                                }}
                                cardModeSetting={cardModeSetting}
                                showSearch={showSearch}
                                reloadButton={reloadButton}
                                manageColumnsButton={manageColumnsButton}
                                endMessage={endMessage}
                                layoutMode={layoutMode}
                                propsSetLoading={setLoading}
                            />}

                    </Col>}
                </>}
                {activeKey === t('attribute') && <>
                    <AttributeManagement
                        extraActionRender={extraActionRender}
                        customFormItems={customFormItems}
                        toolBarRender={toolBarRender}
                        propsUseAttribute={propsUseAttribute}
                        propsOnFinish={propsOnFinish}
                        propsOnBefore={propsOnBefore}
                    />
                </>}
            </Row>
        </LanguageContext.Provider>
    </>
}
export default PositionManagement

const AttributeManagement = ({
    keyPrefix = 'inventory_check.position',
    customColumns = [],
    extraActionRender = () => { },
    customFormItems = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseAttribute = useAttribute,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    actionRef: propsActionRef
}) => {
    const keyPrefix_ = useContext(LanguageContext);
    const { t } = useTranslation("translation", {
        keyPrefix: keyPrefix_ || keyPrefix,
    });

    const navigate = useNavigate();
    const actionRef_ = useRef(null);
    const actionRef = propsActionRef ?? actionRef_
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")

    const onFormFinish = (values) => {
        let submitValues = { ...values };

        let name_language_data = [
            {
                language_manage_id: submitValues?.attribute_name_language_manage_id,
                language_culture_code: "zh-tw",
                language_culture_value: submitValues?.attribute_name,
            },
            {
                language_manage_id: submitValues?.attribute_nameEn_language_manage_id,
                language_culture_code: "en",
                language_culture_value: submitValues?.attribute_nameEn,
            },
        ];
        let data = {
            ...submitValues,
            name_language_data,
        }
        data = setParamsFilter(data)
        if (axiosMode === "post") {
            postAttributeData([data])
        }
        else if (axiosMode === "patch") {
            patchAttributeData([data])
        }
    }

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log({
                selected,
                selectedRows,
                changeRows,
            });
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.attribute_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.attribute_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.attribute_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.attribute_id
                );
                selectRow = selectRow.filter(
                    (row) => row.attribute_id !== record.attribute_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {

        let setValues = { ...record };
        let attribute_name = (setValues?.name_language_data || []).find(
            (ele) => {
                return ele?.language_culture_code === "zh-tw";
            }
        )?.language_culture_value;
        let attribute_name_language_manage_id = (setValues?.name_language_data || []).find(
            (ele) => {
                return ele?.language_culture_code === "zh-tw";
            }
        )?.language_manage_id;
        let attribute_nameEn = (setValues?.name_language_data || []).find(
            (ele) => {
                return ele?.language_culture_code === "en";
            }
        )?.language_culture_value;
        let attribute_nameEn_language_manage_id = (setValues?.name_language_data || []).find(
            (ele) => {
                return ele?.language_culture_code === "en";
            }
        )?.language_manage_id;
        setValues = {
            ...setValues,
            attribute_name,
            attribute_nameEn,
            attribute_name_language_manage_id,
            attribute_nameEn_language_manage_id
        };

        setAxiosMode("patch")
        setModalOpen(true)

        form.resetFields()
        form.setFieldsValue({
            ...setValues,
        })
    }
    const handleOnDeleteRow = (record) => {
        Modal.confirm({
            content: '確定要刪除嗎？',
            onOk: () => {
                deleteAttributeData([{ attribute_id: record.attribute_id }])
            },
            okText: '確定',
            cancelText: '取消'
        })
    }
    const onFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values })
        switch (axiosMode) {
            case "get":

                break;
            case 'post':
                if (status === 'success') {
                    message.success("新增成功")
                    actionRef.current.reloadAndRest()
                } else {
                    message.error("新增失敗")
                }
                break;
            case 'patch':
                if (status === 'success') {
                    message.success("新增成功")
                    actionRef.current.reloadAndRest()
                } else {
                    message.error("新增失敗")
                }
                break;
            case 'delete':
                if (status === 'success') {
                    message.success("刪除成功")
                    actionRef.current.reloadAndRest()
                } else {
                    message.error("刪除失敗")
                }
                break;
            default:
                break;
        }
        setModalLoading(false)
        setModalOpen(false)
    }
    const onBefore = ({ axiosMode, status, values }) => {
        propsOnBefore({ axiosMode, status, values })
    }

    const columns = [
        {
            key: "name",
            title: t('name'),
            dataIndex: "name",
            render: (text, record) => <>
                {(record?.name_language_data || []).find(
                    (ele) => {
                        return ele?.language_culture_code === "zh-tw";
                    }
                )?.language_culture_value}
            </>
        },
        {
            key: "nameEn",
            title: t('nameEn'),
            dataIndex: "nameEn",
            render: (text, record) => <>
                {(record?.name_language_data || []).find(
                    (ele) => {
                        return ele?.language_culture_code === "en";
                    }
                )?.language_culture_value}
            </>
        },
        {
            key: "Action",
            title: t('action'),
            render: (text, record) => {
                return (
                    <>
                        <div className="lowercase w-48">
                            <Button className=' text-blue-600 p-2' variant="ghost" onClick={() => { handleEditRow(record) }}>編輯</Button>
                            /
                            <Button className=' text-red-600 p-2' variant="ghost" onClick={() => handleOnDeleteRow(record)}>{t('delete')}</Button>
                        </div>
                        {extraActionRender(record)}
                    </>
                )
            }

        },
        ...customColumns,
    ]

    const {
        AttributeData,
        getAttributeData,
        postAttributeData,
        patchAttributeData,
        deleteAttributeData
    } = propsUseAttribute({
        onFinish,
        onBefore,
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        checkAll();
    }, []);
    return <>
        <MainModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}

            propsForm={form}

            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}

            onFinish={onFormFinish}
            formElement={<AttributeForm
                customFormItems={customFormItems}
            />}
        />
        <div className="flex items-center py-4">

            <Button
                onClick={handleAddRow}
            >
                <svg className="mr-3" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-plus" viewBox="0 0 16 16">
                    <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5" />
                    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                </svg>
                {t('post_attribute')}
            </Button>
        </div>
        <ProTableOt
            actionRef={actionRef}
            columns={columns}
            check={check}
            setCheck={setCheck}
            rowKey={"attribute_id"}
            request={async (params = {}, sort, filter) => {
                // setAxiosMode("get")
                let newParams = {};
                let order = setOrders(sort);
                newParams = {
                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    ...newParams,
                    order,
                    size: params.pageSize,
                    cur_page: params.current,
                    custom_filter_value: params.keyword ?? "",
                    custom_filter_key: custom_filter_key,
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                // setPageSize(params?.pageSize ?? 20)

                return getAttributeData({
                    ...newParams,
                });
            }}
            toolBarRender={() => toolBarRender([
                <Button
                    type={'default'}
                    style={{
                        color: 'green'
                    }}
                    onClick={() => {
                        actionRef.current.reload();
                    }}
                >
                    {t('import')}
                </Button>,
                <Button
                    type={'default'}
                    style={{
                        color: 'darkgreen'
                    }}
                    onClick={() => {
                        actionRef.current.reload();
                    }}
                >
                    {t('export')}
                </Button>,
                <Button
                    type={'danger'}
                    onClick={() => {
                        actionRef.current.reload();
                    }}
                >
                    {t('delete')}
                </Button>,
            ])}
            rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedRowKeys,
                ...rowSelection,
            }}
            extra_columns={extra_columns}
            set_extra_columns={set_extra_columns}
            manage_columns={true}
        />
    </>
}

const AttributeForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    customFormItems = () => { },
    keyPrefix = 'inventory_check.position'
}) => {
    const [form] = Form.useForm();
    const keyPrefix_ = useContext(LanguageContext);
    const { t } = useTranslation("translation", {
        keyPrefix: keyPrefix_ || keyPrefix,
    });
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            console.log({ minutes })
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5)
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });

    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"attribute_id"}
                            >
                                <div />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name={"attribute_name_language_manage_id"}
                            >
                            </Form.Item>
                            <Form.Item
                                label={t('attribute_name')}
                                name={"attribute_name"}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name={"attribute_nameEn_language_manage_id"}
                            >
                            </Form.Item>
                            <Form.Item
                                label={t('attribute_nameEn')}
                                name={"attribute_nameEn"}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    {customFormItems}
                </Form>
            </Col>
        </Row>
    </>
}
export { AttributeManagement }

const VisualizationManagement = ({
    keyPrefix = 'inventory_check.position',
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form] = Form.useForm();
    const [activeKey, setActiveKey] = useState()
    const [loading, setLoading] = useState(false)
    const onFormFinish = ({
    }) => {
        const values = form.getFieldsValue()
        patchPositionData([values])
    }

    const {
        PositionData,
        getPositionData,
        patchPositionData,
    } = usePosition({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === "patch") {
                if (status === "success") {
                    message.success('儲存成功')
                }
            }
            setLoading(false)
        }
    });

    useEffect(() => {
        if (activeKey !== undefined) {
            form.setFieldsValue(PositionData?.find(item => String(item?.position_id) === String(activeKey)))
            form.setFieldsValue({ 'PositionData': PositionData?.filter(item => String(item?.position_id) === String(activeKey)) })
        } else {
            setActiveKey(PositionData?.find(_ => true)?.position_id !== undefined ? String(PositionData?.find(_ => true)?.position_id) : undefined)
        }
    }, [activeKey, PositionData])

    useEffect(() => {
        getPositionData()
    }, [])
    return <>
        <Tabs
            activeKey={activeKey}
            onChange={setActiveKey}
            items={PositionData.map(record => (
                {
                    key:
                        String(record?.position_id),
                    tab:
                        (
                            record?.name_language_data || []
                        )?.find(
                            (tmp) =>
                                tmp?.language_culture_code ===
                                "zh-tw"
                        )?.language_culture_value || "-",
                }
            ))}
        />
        <Form
            form={form}
            onFinish={onFormFinish}
        >
            <Form.Item
                name={'position_id'}
                hidden
            ></Form.Item>
            <Row>
                <Col
                >
                    <Form.Item
                        name={'row'}
                        label={t('row')}
                    >
                        <InputNumber />
                    </Form.Item>
                </Col>
                <Col
                >
                    <Form.Item
                        name={'column'}
                        label={t('column')}
                    >
                        <InputNumber />
                    </Form.Item>
                </Col>
                <Col
                >
                    <Form.Item
                        name={'height'}
                        label={t('height')}
                    >
                        <InputNumber />
                    </Form.Item>
                </Col>
                <Col span={24}
                >
                    <Form.List
                        name={'position_attribute_data'}
                    >
                        {(fields, { add, remove }) => <>
                            <PositionAttributeFormList
                                fields={fields}
                                add={add}
                                remove={remove}
                            />
                        </>}
                    </Form.List>
                </Col>
            </Row>
            <PositionTest
                propsForm={form}
                propsLoading={loading}
            />
        </Form>
    </>
}
const PositionAttributeFormList = (
    {
        fields = [],
        add = () => { },
        remove = () => { },
        keyPrefix = 'inventory_check.position'
    }
) => {
    const { t } = useTranslation('translation', { keyPrefix })

    const {
        AttributeData,
        getAttributeData
    } = useAttribute({});

    useEffect(() => {
        getAttributeData()
    }, [])

    return <>
        <Row>
            <Col>
                <Button onClick={() => add()}>{t('post_position_attribute_data')}</Button>
            </Col>
        </Row>
        {fields.map(field => <>
            <Row gutter={[8, 8]}>
                <Col span={12}>
                    <Form.Item
                        label={t('attribute')}
                        name={[field.name, 'attribute_id']}
                    >
                        <Select
                            options={AttributeData?.map(record => (
                                {
                                    label: (
                                        record?.name_language_data || []
                                    )?.find(
                                        (tmp) =>
                                            tmp?.language_culture_code === "zh-tw"
                                    )?.language_culture_value || "-",
                                    value: record?.attribute_id
                                }
                            ))}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label={t('content')}
                        name={[field.name, 'content']}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Button onClick={() => remove()}>{t('delete_position_attribute_data')}</Button>
                </Col>
            </Row>
        </>)}
    </>
}